import apiService from '@/services/ApiService';
import { isSnaploreClosedFor } from '@/helpers/appContext';
import { State } from '@/store/state';
import { ActionContext } from 'vuex';
import {
  commitSetDraftsCount,
  commitSetIsOcrModeEnabled,
  commitSetIsOcrRecognitionFinished,
  commitSetMeetingsCount,
  commitSetPersonalArticlesCount,
  commitSetRetentionCount,
} from '@/store/commits/uiCommits';

export const uiActions = {
  async getDraftsCount() {
    try {
      const {
        data: { draftsCount },
      } = await apiService.draft.count();

      commitSetDraftsCount(draftsCount || 0);
    } catch (error) {
      apiService.handleResponseError(error);
    }
  },
  async getMeetingsCount({ state }: ActionContext<State, State>) {
    // SNAP-2241: the API refuses this to a company that pays only for Guides, and the profile page, which such a
    // company keeps, asks for it on every save.
    if (isSnaploreClosedFor(state.company, state.user)) return;

    try {
      const {
        data: { count },
      } = await apiService.meetings.count();

      commitSetMeetingsCount(count || 0);
    } catch (error) {
      apiService.handleResponseError(error);
    }
  },
  async getRetentionCount() {
    try {
      const {
        data: { count },
      } = await apiService.retention.count();

      commitSetRetentionCount(count || 0);
    } catch (error) {
      apiService.handleResponseError(error);
    }
  },
  async getPersonalArticlesCount({ state }: ActionContext<State, {}>) {
    const personalWorkspaceId = state.user?.personalWorkspaceId;

    if (!personalWorkspaceId) {
      commitSetPersonalArticlesCount(0);
      return;
    }

    try {
      const {
        data: { articlesCount },
      } = await apiService.workspace.getArticlesCount(personalWorkspaceId, true);

      commitSetPersonalArticlesCount(articlesCount);
    } catch (error) {
      apiService.handleResponseError(error);
    }
  },
  disableOcrMode({ state }: ActionContext<State, {}>) {
    if (!state.ui.isOcrModeEnabled) return;
    commitSetIsOcrModeEnabled(false);
    commitSetIsOcrRecognitionFinished(false);
  },
  async enableOcrMode({ state }: ActionContext<State, {}>) {
    if (state.ui.isOcrModeEnabled) return;
    await state.videoPlayerRef?.stop();
    commitSetIsOcrModeEnabled(true);
  },
};
